import React, { useState, useEffect } from 'react';
import { Link as ScrollLink } from 'react-scroll';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="container navbar-container">
        <RouterLink to="/" className="logo">Nozomi Robotics</RouterLink>

        <div className="menu-icon" onClick={toggleMenu}>
          <div className={`menu-icon-bar ${mobileMenuOpen ? 'open' : ''}`}></div>
          <div className={`menu-icon-bar ${mobileMenuOpen ? 'open' : ''}`}></div>
          <div className={`menu-icon-bar ${mobileMenuOpen ? 'open' : ''}`}></div>
        </div>

        <div className={`nav-links ${mobileMenuOpen ? 'active' : ''}`}>
          <RouterLink to="/about" onClick={() => setMobileMenuOpen(false)}>About</RouterLink>

          {isHomePage ? (
            <>
              <ScrollLink to="features" smooth={true} duration={500} onClick={() => setMobileMenuOpen(false)}>Features</ScrollLink>
              <ScrollLink to="kit" smooth={true} duration={500} onClick={() => setMobileMenuOpen(false)}>Kit Details</ScrollLink>
              <ScrollLink to="research" smooth={true} duration={500} onClick={() => setMobileMenuOpen(false)}>Research</ScrollLink>
              <ScrollLink to="how-it-works" smooth={true} duration={500} onClick={() => setMobileMenuOpen(false)}>How It Works</ScrollLink>
              <ScrollLink to="contact" smooth={true} duration={500} onClick={() => setMobileMenuOpen(false)}>Contact</ScrollLink>
            </>
          ) : (
            <>
              <RouterLink to="/#features" onClick={() => setMobileMenuOpen(false)}>Features</RouterLink>
              <RouterLink to="/#kit" onClick={() => setMobileMenuOpen(false)}>Kit Details</RouterLink>
              <RouterLink to="/#research" onClick={() => setMobileMenuOpen(false)}>Research</RouterLink>
              <RouterLink to="/#how-it-works" onClick={() => setMobileMenuOpen(false)}>How It Works</RouterLink>
              <RouterLink to="/#contact" onClick={() => setMobileMenuOpen(false)}>Contact</RouterLink>
            </>
          )}
          <RouterLink to="/pilot" onClick={() => setMobileMenuOpen(false)}>Pilot</RouterLink>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;